import {RMCLayout} from '@/layout/RMCLayout';
import {SentryRoutes} from '@/main';
import lazyWithPreload from 'react-lazy-with-preload';
import {Navigate, Route} from 'react-router-dom';
import {importWithRetry} from '@/utils/chunkReloadOperations';

const DashboardPage = lazyWithPreload(() =>
  importWithRetry(() =>
    import('../../pages/ENT/Dashboard/DashboardPage/RMCDashboardPage').then(
      module => ({
        default: module.RMCDashboardPage,
      }),
    ),
  ),
);

export const RMCRoot = () => {
  return (
    <SentryRoutes>
      <Route element={<RMCLayout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </SentryRoutes>
  );
};
